import { ConfirmSubmitModal } from '@/components/shared/modal'

type Props = {
  visible: boolean
  onClose: () => void
  onSubmit: () => void
}

export const RecallInviteModal = ({ visible, onClose, onSubmit }: Props) => (
  <ConfirmSubmitModal
    noBackdrop
    opened={visible}
    header="Отозвать приглашение"
    message="Отозвав приглашение, приглашённый пользователь не сможет авторизоваться в приложении"
    closeButtonText="Оставить"
    submitButtonText="Отозвать"
    submitButtonClassName="!bg-red-80 !border-red-80"
    onClose={onClose}
    onSubmit={onSubmit}
  />
)
